// extracted by mini-css-extract-plugin
module.exports = {"image":"category-tiles_image__0mV7l","arrow":"category-tiles_arrow__MT1t7","tile":"category-tiles_tile__npO_w"};